/** Romanian is the default locale; every user-facing string starts here. */
export default {
  common: {
    unexpected: 'Ceva nu a mers bine. Încearcă din nou.',
    offline: 'Nu am putut contacta serverul. Încearcă din nou.',
    appName: 'SHIFT',
    retry: 'Reîncearcă',
    signOut: 'Ieși din cont',
    loading: 'Se încarcă…',
  },
  nav: {
    account: 'Contul meu',
    jobs: 'Comenzile mele',
    book: 'Comandă',
    addresses: 'Adresele mele',
    referrals: 'Invită un prieten',
    cards: 'Carduri',
    company: 'Firma mea',
    help: 'Ajutor',
  },
  auth: {
    title: 'Intră în cont',
    subtitle: 'Comandă servicii pentru casă sau firmă, cu plata securizată.',
    email: 'E-mail sau telefon',
    password: 'Parolă',
    submit: 'Continuă',
    emailRequired: 'Introdu e-mailul sau numărul de telefon.',
    passwordRequired: 'Introdu parola.',
    wrongApp: 'Acest cont este de lucrător sau de firmă. Intră în portalul pentru firme, nu aici.',
  },
  register: {
    title: 'Creează-ți cont',
    subtitle: 'Ai nevoie de un cont ca să comanzi un serviciu și să urmărești lucrarea.',
    name: 'Nume și prenume',
    nameRequired: 'Introdu numele tău.',
    email: 'E-mail',
    emailRequired: 'Introdu o adresă de e-mail validă.',
    phone: 'Telefon (opțional)',
    phoneHint: 'Îl folosim ca lucrătorul să te poată contacta la fața locului.',
    password: 'Parolă',
    passwordHint: 'Minimum {min} caractere.',
    passwordTooShort: 'Parola trebuie să aibă cel puțin {min} caractere.',
    submit: 'Creează contul',
    haveAccount: 'Ai deja cont?',
    signIn: 'Intră în cont',
    noAccount: 'Nu ai cont?',
    createAccount: 'Creează unul',
    problem: {
      EMAIL_ALREADY_REGISTERED: 'Există deja un cont cu acest e-mail. Încearcă să intri în cont.',
      VALIDATION_FAILED: 'Verifică datele introduse și încearcă din nou.',
      UNEXPECTED: 'Nu am putut crea contul. Încearcă din nou.',
    },
  },
  addresses: {
    shareWithCompany: 'Adresă de firmă',
    shareWithCompanyHint:
      'Colegii tăi o vor vedea și vor putea comanda la ea. Adresele personale rămân doar ale tale.',
    search: 'Caută adresa',
    searchExplainer:
      'Scrie strada și orașul, apoi alege din listă. Coordonatele sunt completate automat.',
    searchEmpty: 'Nu am găsit nicio adresă. Încearcă altfel sau folosește locația telefonului.',
    positionReady: 'Adresă localizată.',
    title: 'Adresele tale',
    subtitle: 'Adresa spune firmei unde să vină și decide ce firme te pot prelua.',
    addTitle: 'Adaugă o adresă',
    default: 'Implicită',
    locationExplainer:
      'Salvăm adresa cu poziția de pe telefon, așa că adaug-o din locul respectiv. ' +
      'Dacă ești în altă parte, adaug-o când ajungi acolo.',
    locate: 'Folosește locația mea',
    located: 'Locație preluată',
    accuracy: 'Precizie: aproximativ {metres} m.',
    needsLocation: 'Preia mai întâi locația, ca lucrătorul să știe unde să vină.',
    addressLine: 'Strada și numărul',
    addressRequired: 'Introdu strada și numărul.',
    city: 'Localitatea',
    cityRequired: 'Introdu localitatea.',
    label: 'Nume (opțional) — ex. Acasă, Birou',
    floor: 'Etaj',
    apartment: 'Apartament',
    accessNotes: 'Cum se ajunge (opțional)',
    accessNotesHint: 'Cod la interfon, ce ușă, unde se parchează.',
    save: 'Salvează adresa',
    problem: {
      DENIED:
        'Nu ne-ai dat acces la locație. Activează-o din setările browserului și încearcă din nou.',
      UNAVAILABLE: 'Nu am putut prelua locația. Verifică semnalul și încearcă din nou.',
      UNSUPPORTED: 'Browserul acesta nu poate transmite locația. Încearcă de pe telefon.',
      INACCURATE:
        'Locația e prea imprecisă ({accuracy} m) ca să trimitem un lucrător după ea. ' +
        'Ieși în aer liber sau încearcă din nou peste câteva secunde.',
      REFUSED: 'Nu am putut salva adresa. Verifică datele și încearcă din nou.',
    },
  },
  home: {
    title: 'Lucrările tale',
    subtitle: 'Comenzile în desfășurare și cele încheiate.',
    newBooking: 'Comandă un serviciu',
    noJobs: 'Nu ai nicio lucrare încă.',
    emergency: 'Urgență',
  },
  booking: {
    noServices: 'Momentan nu sunt servicii disponibile.',
    otherServices: 'Alte servicii',
    changeService: 'Schimbă serviciul',
    estimatedMinutes: 'circa {minutes} min',
    title: 'Comandă un serviciu',
    subtitle: 'Alegi serviciul, adresa și trimiți câteva poze. Plătești abia la final.',
    service: 'Serviciul',
    address: 'Adresa',
    photos: 'Fotografii ({min}–{max})',
    photosHint: 'Ajută firma să vină pregătită și scurtează timpul pe teren.',
    description: 'Detalii (opțional)',
    emergency: 'Urgență Maximă',
    emergencyHint: 'Ajunge mai repede la firme, cu tarif mai mare.',
    holdExplainer: 'Blocăm suma pe card acum și o încasăm doar după ce lucrarea este finalizată.',
    submit: 'Trimite comanda',
    uploading: 'Se încarcă fotografiile…',
    booking: 'Se creează comanda…',
    paying: 'Se blochează suma pe card…',
    noAddress: 'Adaugă mai întâi o adresă ca să poți comanda.',
    noCard: 'Adaugă un card ca să poți comanda. Blocăm suma abia la trimiterea comenzii.',
    addCard: 'Adaugă un card',
    addAddress: 'Adaugă o adresă',
    retryPaysExistingJob: 'Comanda există deja — reîncercarea doar reia plata.',
    couponCode: 'Cod promoțional',
    couponHint: 'Îl verificăm înainte să comanzi, ca să vezi prețul final.',
    couponApply: 'Verifică',
    couponApplied: 'Reducere {discount}. Plătești {total}.',
  },
  cards: {
    title: 'Cardurile mele',
    subtitle: 'Plătești cu cardul salvat. Datele cardului nu ajung niciodată la noi.',
    card: 'Card',
    isDefault: 'Card implicit',
    makeDefault: 'Folosește implicit',
    remove: 'Șterge',
    add: 'Adaugă un card',
    newCard: 'Card nou',
    save: 'Salvează cardul',
    cancel: 'Renunță',
    empty: 'Nu ai niciun card salvat. Ai nevoie de unul ca să poți comanda.',
    securityNote:
      'Datele cardului sunt introduse direct la procesatorul de plăți, într-un câmp securizat. Noi păstrăm doar ultimele patru cifre.',
    holdNote: 'La comandă blocăm suma pe card și o încasăm abia după ce lucrarea este finalizată.',
    problem: {
      notAvailable: 'Plata cu cardul nu este încă disponibilă. Revenim în scurt timp.',
      providerUnreachable:
        'Nu am putut încărca formularul de card. Verifică conexiunea și încearcă din nou.',
      unexpected: 'Ceva nu a mers. Încearcă din nou peste câteva momente.',
    },
  },
  company: {
    title: 'Contul firmei',
    subtitle: 'Comenzile colegilor tăi ajung pe o singură factură lunară.',
    cui: 'CUI',
    members: 'Cine comandă pe contul firmei',
    inviteEmail: 'E-mailul colegului',
    invite: 'Trimite invitația',
    inviteHint:
      'Orice membru poate invita. Linkul poate fi folosit o singură dată și expiră în 14 zile.',
    invited: 'Am trimis invitația către {email}.',
    register: 'Înregistrează firma',
    registerHint:
      'Verificăm CUI-ul la registrul comerțului. O firmă radiată sau în insolvență nu poate fi facturată.',
    cuiField: 'CUI',
    cuiHint: 'Cu sau fără RO.',
    billingEmail: 'E-mail pentru facturi',
    billingEmailHint: 'Acolo trimitem factura lunară.',
    tradeName: 'Nume comercial (opțional)',
    tradeNameHint: 'Implicit folosim numele din registru — el apare pe factură.',
    registerAction: 'Înregistrează',
  },
  join: {
    title: 'Intră în contul firmei',
    subtitle: 'Ai fost invitat să comanzi pe contul unei firme.',
    password: 'Parolă',
    passwordHint:
      'Dacă ai deja un cont SHIFT pe această adresă, folosește parola pe care o ai. Altfel, alege una nouă (minim 10 caractere).',
    name: 'Numele tău',
    nameHint: 'Necesar doar dacă îți creezi acum contul.',
    submit: 'Acceptă invitația',
  },
  assistant: {
    title: 'Întreabă despre comenzile tale',
    hint: 'Răspunde doar din comenzile tale și din întrebările frecvente. Nu poate plasa, modifica sau anula nimic.',
    question: 'Întrebarea ta',
    ask: 'Întreabă',
    grounded: 'Răspuns pe baza a {count} comenzi ale tale.',
    fromFaq: 'Răspuns pe baza întrebărilor frecvente — nu ai încă nicio comandă.',
  },
  firmSignup: {
    title: 'Înscrie-ți firma',
    subtitle: 'Primești comenzi de la clienți din zona ta. Plata este garantată de platformă.',
    cui: 'CUI',
    cuiHint: 'Cu sau fără RO. Îl verificăm la registrul comerțului.',
    email: 'E-mail de contact',
    emailHint: 'Aici trimitem invitația de activare, după aprobare.',
    phone: 'Telefon (opțional)',
    submit: 'Trimite cererea',
    whatHappens:
      'Verificăm firma la registrul comerțului, apoi cererea intră la aprobare. Îți scriem pe e-mail în ambele cazuri.',
    queued: '{name} a fost înregistrată și așteaptă aprobarea.',
    categories: 'Servicii pentru care te califici, după codurile CAEN:',
    noCategories:
      'Codurile CAEN înregistrate nu acoperă niciun serviciu de pe platformă. Cererea rămâne înregistrată — scrie-ne dacă firma are coduri suplimentare.',
    nextStep: 'După aprobare trimitem linkul de activare pe {email}.',
    backToLogin: 'Înapoi la autentificare',
    problem: {
      INVALID_CUI: 'CUI-ul nu este valid. Verifică cifrele.',
      COMPANY_NOT_FOUND: 'Nu am găsit nicio firmă cu acest CUI în registrul comerțului.',
      COMPANY_NOT_TRADING:
        'Registrul comerțului arată firma ca radiată, dizolvată sau în insolvență. Nu putem înscrie o firmă care nu poate funcționa legal.',
      TENANT_ALREADY_REGISTERED: 'Firma este deja înscrisă. Verifică e-mailul primit sau scrie-ne.',
      VALIDATION_FAILED: 'Verifică datele completate.',
      UNEXPECTED: 'Ceva nu a mers. Încearcă din nou peste câteva momente.',
    },
  },
  help: {
    title: 'Întrebări frecvente',
    subtitle: 'Cum funcționează comanda, plata și garanția.',
    empty: 'Încă nu am publicat răspunsuri aici.',
  },
  referrals: {
    title: 'Invită un prieten',
    subtitle: 'Prietenul primește o reducere la prima comandă, tu primești una când o plătește.',
    yourCode: 'Codul tău',
    copy: 'Copiază',
    copied: 'Copiat',
    invited: 'au folosit codul',
    rewarded: 'au comandat și plătit',
    earned: 'ai câștigat',
    paidOnFirstJob:
      'Recompensa ta apare după ce prietenul plătește prima lucrare — nu la crearea contului.',
    haveACode: 'Ai primit un cod?',
    enterCode: 'Codul prietenului',
    enterCodeHint: 'Poate fi scris cu spații sau litere mici.',
    use: 'Folosește codul',
    redeemed: 'Gata. Codul tău de reducere este {code} — îl poți folosi la prima comandă.',
  },
  job: {
    // Shown while the job is still loading and its service name is unknown.
    title: 'Lucrarea',
    call: 'Sună lucrătorul',
    callHint: 'Număr temporar — nici tu, nici el nu vedeți numărul celuilalt.',
    address: 'Adresa',
    firm: 'Firma',
    worker: 'Lucrător',
    eta: 'Ora estimată',
    total: 'Total',
    includesExtras: 'include {extras} extra',
    timeline: 'Istoric',
    invoice: 'Factură',
    invoiceReady: 'Factura a fost emisă de firmă.',
    finished: 'Lucrarea este încheiată.',
  },
  noShow: {
    prompt: 'Lucrătorul nu a ajuns încă la ora estimată. Ce vrei să faci?',
    keepWaiting: 'Mai aștept',
    cancelFree: 'Anulează gratuit',
  },
  rating: {
    title: 'Cum a fost?',
    comment: 'Comentariu (opțional)',
    submit: 'Trimite evaluarea',
    tipHint: 'Bacșișul ajunge integral la firmă — platforma nu reține comision.',
    tipAmount: 'Bacșiș (bani)',
    tipSubmit: 'Trimite bacșiș',
  },
  jobStatus: {
    DRAFT: 'În pregătire',
    PAYMENT_PENDING: 'Se procesează plata',
    PAYMENT_FAILED: 'Plata a eșuat',
    SEARCHING_FOR_FIRM: 'Căutăm o firmă',
    NO_COVERAGE: 'Nicio firmă disponibilă',
    ACCEPTED_BY_FIRM: 'Preluată de firmă',
    ASSIGNED_TO_WORKER: 'Lucrător alocat',
    WORKER_EN_ROUTE: 'Lucrătorul e pe drum',
    IN_PROGRESS: 'În lucru',
    CHANGE_ORDER_PENDING: 'Aștepți confirmarea unor extra',
    CANCELLATION_REQUESTED: 'Firma a cerut anularea',
    COMPLETED: 'Finalizată',
    DISPUTED: 'În dispută',
    WARRANTY_CLAIMED: 'Garanție solicitată',
    CANCELLED_BY_CLIENT: 'Anulată de tine',
    CANCELLED_BY_FIRM: 'Anulată de firmă',
    CANCELLED_NO_SHOW: 'Anulată — lucrătorul nu a ajuns',
    CANCELLED_ADMIN: 'Anulată de platformă',
  },
  notFound: {
    title: 'Pagina nu există',
    subtitle: 'Verifică adresa sau întoarce-te la pagina principală.',
    back: 'Înapoi acasă',
  },
} as const;
